import { render, staticRenderFns } from "./customDrawer.vue?vue&type=template&id=56e100aa&scoped=true"
import script from "./customDrawer.vue?vue&type=script&lang=js"
export * from "./customDrawer.vue?vue&type=script&lang=js"
import style0 from "./customDrawer.vue?vue&type=style&index=0&id=56e100aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e100aa",
  null
  
)

export default component.exports